import { connect } from 'react-redux'
import activityContentSelector from './activityContentSelector'
import requestEditMessage from '../../../sagas/requestEditMessage'
import requestAddBookmark from '../../../sagas/requestAddBookmark'
import requestRemoveBookmark from '../../../sagas/requestRemoveBookmark'
import requestRemoveMessage from '../../../sagas/requestRemoveMessage'
import ActivityContent from './ActivityContent'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  activityContentSelector,
  {
    requestEditMessage,
    requestRemoveMessage,
    requestAddBookmark,
    requestRemoveBookmark
  },
  null,
  {
    forwardRef: true
  }
)(ActivityContent))
